import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import Button from './Button'
import './SubmitField.css'

const SubmitField = props => {
  const { wide, fluid, modifier, disabled, loading, labelLoading, form, showLoadingIndicator, onClick } = props
  let label = props.label
  let extras = props.extras
  const attrs = {}

  if (fluid) {
    extras += ' fluid'
  }

  if (wide) attrs.wide = wide
  if (extras) attrs.extras = extras
  if (onClick) attrs.onClick = onClick
  if (form) attrs.form = form
  if (modifier) attrs.modifier = modifier
  if (loading && labelLoading) label = labelLoading

  const buttonClasses = classnames({
    'SubmitField-button': true,
    'SubmitField-button--fluid': fluid
  })
  return (
    <div className='SubmitField'>
      <div className={buttonClasses}>
        <Button type='submit' disabled={disabled} loading={showLoadingIndicator && loading} {...attrs}>
          {label}
        </Button>
      </div>
    </div>
  )
}

SubmitField.displayName = 'SubmitField'

SubmitField.propTypes = {
  disabled: PropTypes.oneOfType([ PropTypes.string, PropTypes.bool ]),
  extras: PropTypes.string,
  fluid: PropTypes.oneOfType([ PropTypes.string, PropTypes.bool ]),
  form: PropTypes.string,
  label: PropTypes.string.isRequired,
  labelLoading: PropTypes.string,
  loading: PropTypes.bool,
  modifier: PropTypes.string,
  onClick: PropTypes.func,
  showLoadingIndicator: PropTypes.bool,
  wide: PropTypes.string
}

export default SubmitField



// WEBPACK FOOTER //
// ./ui/SubmitField.js